(function () {
  'use strict';
  if (customElements.get('pf-auth-media')) return;

  class PfAuthMedia extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.video = null;
      this.desktop = matchMedia('(min-width: 1024px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = !('IntersectionObserver' in window);
      this.sync = this.updatePlayback.bind(this);
      const options = { signal: this.controller.signal };
      this.desktop.addEventListener('change', this.sync, options);
      this.reduced.addEventListener('change', this.sync, options);
      document.addEventListener('visibilitychange', this.sync, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.updatePlayback();
        }, { threshold: 0.01 });
        this.observer.observe(this);
      }
      this.updatePlayback();
    }

    shouldPlay() {
      return this.desktop.matches && !this.reduced.matches && !document.hidden && this.visible;
    }

    updatePlayback() {
      if (!this.shouldPlay()) {
        if (this.video) this.video.pause();
        this.classList.remove('is-playing');
        return;
      }
      if (!this.video) {
        if (!this.querySelector('video')) {
          const template = this.querySelector('template');
          if (!template) return;
          this.insertBefore(template.content.cloneNode(true), this.querySelector('.pf-auth__video-scrim'));
        }
        this.video = this.querySelector('video');
        if (!this.video) return;
        const options = { signal: this.controller.signal };
        this.video.addEventListener('playing', () => {
          if (this.shouldPlay()) this.classList.add('is-playing');
        }, options);
        this.video.addEventListener('error', () => this.classList.remove('is-playing'), options);
        this.video.muted = true;
        this.video.preload = 'metadata';
        this.video.load();
      }
      this.video.muted = true;
      if (this.video.paused) this.video.play().catch(() => this.classList.remove('is-playing'));
    }

    disconnectedCallback() {
      if (this.video) this.video.pause();
      if (this.observer) this.observer.disconnect();
      if (this.controller) this.controller.abort();
      this.classList.remove('is-playing');
      this.controller = null;
      this.observer = null;
    }
  }

  customElements.define('pf-auth-media', PfAuthMedia);
})();
